import { Route } from '@angular/router';
import { InitialDataResolver } from './app.resolvers';
import {AuthGuard, LayoutComponent, NoAuthGuard} from "abc";

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/example'
    {path: '', pathMatch : 'full', redirectTo: 'dashboard'},

    // Redirect signed in user
    //
    // After the user signs in, the sign in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    {path: 'signed-in-redirect', pathMatch : 'full', redirectTo: 'dashboard'},


    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'sign-in', loadChildren: () => import('libs/abc/src/lib/auth/sign-in/sign-in.module').then(m => m.AuthSignInModule)},
            {path: 'sign-up', loadChildren: () => import('libs/abc/src/lib/auth/sign-up/sign-up.module').then(m => m.AuthSignUpModule)},
            {path: 'confirmation-success', loadChildren: () => import('libs/abc/src/lib/auth/confirmation-success/confirmation-success.module').then(m => m.AuthConfirmationSuccessModule)},
            {path: 'confirmation-required', loadChildren: () => import('libs/abc/src/lib/auth/confirmation-required/confirmation-required.module').then(m => m.AuthConfirmationRequiredModule)},
            {path: 'forgot-password', loadChildren: () => import('libs/abc/src/lib/auth/forgot-password/forgot-password.module').then(m => m.AuthForgotPasswordModule)},
            {path: 'changepass', loadChildren: () => import('libs/abc/src/lib/auth/reset-password/reset-password.module').then(m => m.AuthResetPasswordModule)},

        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [

            {path: 'sign-out', loadChildren: () => import('libs/abc/src/lib/auth/sign-out/sign-out.module').then(m => m.AuthSignOutModule)},
            {path: 'unlock-session', loadChildren: () => import('libs/abc/src/lib/auth/unlock-session/unlock-session.module').then(m => m.AuthUnlockSessionModule)}

        ]
    },

    // Admin routes
    {
        path       : '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component  : LayoutComponent,
        resolve    : {
            initialData: InitialDataResolver,
        },
        children   : [
            {path: 'users', loadChildren: () => import('libs/abc/src/lib/users/users.module').then(m => m.UsersModule)},
            {path: 'dashboard', loadChildren: () => import('libs/abc/src/lib/dashboard/project/project.module').then(m => m.ProjectModule)},
            {path: 'support', loadChildren: () => import('libs/abc/src/lib/pages/support/support.module').then(m => m.SupportModule)},
            {path: 'changelog', loadChildren: () => import('libs/abc/src/lib/pages/changelog/changelog.module').then(m => m.ChangelogModule)},
            {path: 'profile', loadChildren: () => import('libs/abc/src/lib/profile/profile.module').then(m => m.ProfileModule)},
            {path: 'parts', loadChildren: () => import('libs/abc/src/lib/parts/parts.module').then(m => m.PartsModule)},
            {path: 'warehouses', loadChildren: () => import('libs/abc/src/lib/warehouses/warehouses.module').then(m => m.WarehousesModule)},
            {path: 'transactions', loadChildren: () => import('libs/abc/src/lib/transactions/transactions.module').then(m => m.TransactionsModule)},
            {path: 'warehouse-status', loadChildren: () => import('libs/abc/src/lib/warehouse-status/warehouse-status.module').then(m => m.WarehouseStatusModule)},

            // maintenance, error & Catch all
            {path: 'maintenance', loadChildren: () => import('libs/abc/src/lib/pages/maintenance/maintenance.module').then(m => m.MaintenanceModule)},
            {path: '500-internal-server-error', loadChildren: () => import('libs/abc/src/lib/pages/error/error-500/error-500.module').then(m => m.Error500Module)},
            {path: '404-not-found', pathMatch: 'full', loadChildren: () => import('libs/abc/src/lib/pages/error/error-404/error-404.module').then(m => m.Error404Module)},
            {path: '**', redirectTo: '404-not-found'}
        ]
    }
];
